import React, { useEffect, useState } from "react";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_kratos";
import useHttp from "../../../hook/use-http";
import NoTableData from "./NoTableData";
import ChartLoader from "./ChartLoader";
import { useNavigate } from "react-router-dom";
import WaterMark from "../DashboardMain_Kratos/WaterMark";

export default function CriticalTables_Kratos({ gloablfilter, extraThings }) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [criticalTableData, setCriticalTableData] = useState([]);

  const navigate = useNavigate();
  const handleRowClick = (vehicleId) => {
    navigate(`/dashboard_kratos/rca_kratos/${vehicleId}`);
  };

  const critical_response = (data) => {
    setCriticalTableData(data);
  }

  useEffect(() => {
    if (extraThings["packType"].length === 1) {
      fetchData({ url: API_URL_MAIN + "critical_vehicles_kratos/" + extraThings["apiEndPoint"], body: { filterdata: gloablfilter, packType: extraThings["packType"] } }, critical_response)
    } else {
      fetchData({ url: API_URL_MAIN + "critical_vehicles_kratos/" + extraThings["apiEndPoint"], body: { filterdata: gloablfilter, imbalanceType: extraThings["packType"] } }, critical_response)
    }
  }, [gloablfilter])

  return (
    <>
      <div className={`mt-3 ${('rightZero' in extraThings) ? '' : 'pr-0'}`}>
        <div className="chargingChartboxNew_Kratos">
          <div className="v-title chargingTitleChart_Kratos">
            <div className="row p-2">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <b>{extraThings["title"]}</b>
              </div>
            </div>
          </div>
          <div className="tableContent_Kratos px-2" style={{ overflowY: 'scroll', height: '248px' }}>
            <WaterMark />
            <table className="table table-striped">
              <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
                <tr>
                  <th scope="col">Vin</th>
                  <th scope="col">{extraThings["withDropdown"].substring(1)}{(extraThings["withDropdown"].substring(1) === "Temp" ? "(°C)" : "(Min)")}</th>
                </tr>
              </thead>
              <tbody>
                {
                  (isLoading) ? <ChartLoader /> :
                    (criticalTableData.length == 0) ? <NoTableData /> : criticalTableData.map(x => {
                      let item = ""
                      // if (extraThings["packType"].length === 1) {
                      //   item = extraThings["packType"] + "Max_Cell_Temp"
                      // } else {
                        // item = extraThings["packType"]
                      // }
                      return (
                        <tr key={x.key.vehicleId}>
                          <td scope="row" className="hand_geture" /* onClick={() => handleRowClick(x.key.vehicleId)} */>{x.key.vehicleId}</td>
                          <td>{x["Max_Cell_Temp"]?.value.toFixed(2)}</td>
                        </tr>
                      )
                    })
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}
